import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Mint Price")
const _hoisted_4 = ["textContent"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Live Date")
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Mint Stats")
const _hoisted_9 = { class: "text-gray-500" }
const _hoisted_10 = { class: "flex justify-between space-x-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Items Available", -1)
const _hoisted_12 = { class: "flex-shrink-0" }
const _hoisted_13 = { class: "flex justify-between space-x-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Items Redeemed", -1)
const _hoisted_15 = { class: "flex-shrink-0" }
const _hoisted_16 = { class: "flex justify-between space-x-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Items Remaining", -1)
const _hoisted_18 = { class: "flex-shrink-0" }
const _hoisted_19 = {
  key: 0,
  class: "flex justify-between space-x-4"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "truncate" }, "Royalties", -1)
const _hoisted_21 = { class: "flex-shrink-0" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Creators")
const _hoisted_24 = { class: "text-gray-500" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Config Not Found")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "The Config account related to this Candy Machine was not found. It was likely withdrawn once all items were minted.", -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mb-8" }

import {
  computed, onBeforeUnmount, Ref, ref, toRefs,
} from 'vue';
import dayjs, { Dayjs } from 'dayjs';
import { round } from 'lodash-es';
import { AccountPresenter, CandyMachineAccount } from '@/models';
import { useCountdown } from '@/composables';
import { getAccountRoute, shortenPublicKey } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: CandyMachineAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

// Live date.
const liveDateRaw = account.value.decodedData.data.goLiveDate;
const liveDate: Dayjs | null = liveDateRaw ? dayjs.unix(liveDateRaw) : null;
const liveDateFormatted: string = liveDate ? liveDate.format('LLL') : 'Not Set';
const { countdown, invalidateCountdown, isLive } = useCountdown(liveDate);
const relativeDate = computed(() => (isLive.value ? liveDate?.fromNow() : `In ${countdown.value}`));
onBeforeUnmount(invalidateCountdown);

// Mint stats.
const itemsAvailable: Ref<number> = ref(account.value.decodedData.data.itemsAvailable.toNumber());
const itemsRedeemed: Ref<number> = ref(account.value.decodedData.itemsRedeemed.toNumber());
const itemsRemaining = computed(() => itemsAvailable.value - itemsRedeemed.value);
const soldOut = computed(() => itemsRedeemed.value >= itemsAvailable.value);

// Royalties.
const royalties = computed(() => {
  if (!account.value.configAccount) return null;
  return round(account.value.configAccount.decodedData.data.sellerFeeBasisPoints / 100, 2);
});

// Creators.
const creators = computed(() => {
  if (!account.value.configAccount) return [];
  return account.value.configAccount.decodedData.data.creators;
});

// Config lines.
const configLinesToShow = 3;
const configLines = computed(() => {
  if (!account.value.configAccount) return [];
  if (soldOut.value) return account.value.configAccount.configLines.slice(-configLinesToShow);
  return account.value.configAccount.configLines.slice(itemsRedeemed.value, itemsRedeemed.value + configLinesToShow);
});

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_config_line_card = _resolveComponent("config-line-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "text-gray-500",
          textContent: _toDisplayString(_unref(account).mintPrice.formattedWithSymbol)
        }, null, 8, _hoisted_4),
        _createVNode(_component_base_label, { class: "mt-4" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "text-gray-500",
          textContent: _toDisplayString(_unref(liveDateFormatted))
        }, null, 8, _hoisted_6),
        (_unref(liveDate))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "text-gray-500",
              textContent: _toDisplayString(_unref(relativeDate))
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(itemsAvailable.value), 1)
          ]),
          _createElementVNode("li", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(itemsRedeemed.value) + " / " + _toDisplayString(itemsAvailable.value), 1)
          ]),
          _createElementVNode("li", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(itemsRemaining)) + " / " + _toDisplayString(itemsAvailable.value), 1)
          ]),
          (_unref(account).configAccount)
            ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(royalties)) + " %", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(account).configAccount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_base_label, null, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(creators), (creator) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: creator.address.toBase58(),
                  class: "flex justify-between space-x-4"
                }, [
                  _createVNode(_component_router_link, {
                    class: "font-mono hover:text-gray-900",
                    to: _unref(getAccountRoute)(creator.address)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(shortenPublicKey)(creator.address, 10)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", null, _toDisplayString(creator.share) + "%", 1)
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createVNode(_component_base_label, null, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            }),
            _hoisted_27
          ]))
    ]),
    (_unref(account).configAccount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_component_base_label, {
            textContent: _toDisplayString(_unref(soldOut) ? 'Latest mints' : 'Next mints')
          }, null, 8, ["textContent"]),
          _createElementVNode("ul", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configLines), (configLine) => {
              return (_openBlock(), _createElementBlock("li", {
                key: configLine.uri
              }, [
                _createVNode(_component_config_line_card, { "config-line": configLine }, null, 8, ["config-line"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})